
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Logout from '../../../containers/Pages/Login/Logout'
import { Button, message } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { LeftCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'antd'
import LanListChanelWiseWithPayout from './LanListChanelWiseWithPayout'
import { addReamapRemarkAction, getPricingPartnerdata } from '../../../redux/PayoutLanData/Action'
import { payoutLandataChanelWiseAction, payoutPartnerChannelWiseLansearch } from '../../../redux/PayoutLanData/Action'
import { use } from 'react'
import useSession from '../../CustomLogout/useSession'
import { useMemo } from 'react'
import { debounce, get } from 'lodash'

export const LanListDetailChanalwise = (props) => {
  const navigate = useNavigate();
  const { fileName, reportId } = useParams();
  const location = useLocation();
  const status = location.state?.filestatus;
  const handleSessionExpired = useSession();
  const [landatasource, setLanDatasource] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [makerAction, setMakerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
  });

  const [searchTextTable, setSearchTextTable] = useState("");



  const getfilemonth = fileName?.split("-")[0];
  const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  const prevMonthIndex = (new Date().getMonth() - 1 + 12) % 12;
  const prevMonthShortName = monthNames[prevMonthIndex];





  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };



  const totalPageSizeSet = useRef(false);

  const debouncedSearch = useMemo(() =>
    debounce(async (value) => {
      const searchValue = String(value || "").trim().toLowerCase();

      if (!searchValue) {
        setPagination(prev => ({
          ...prev,
          current: 1,
          pageSize: 10,
        }));
        await fetchPayoutLandataChanelWise(1, 10);
        totalPageSizeSet.current = false;
        return;
      }

      try {


        const sizeToUse = totalPageSizeSet.current
          ? pagination.pageSize
          : 400;

        let response = await props.payoutPartnerChannelWiseLansearch({
          accessToken: props.accessToken,
          reportId: reportId,
          searchString: searchValue,
          page: 0,
          size: sizeToUse,
        });

        const errorCode = response?.response?.data?.error?.errorCode || response.errorCode;
        if (
          errorCode &&
          errorCode === 403 &&
          (response?.response?.data?.error?.errorCode || response.errorCode)
        ) {
          handleSessionExpired();
          return;
        }

        const searchData = response.content || [];
        setLanDatasource(searchData);


        if (!totalPageSizeSet.current || response.totalElements !== pagination.total) {
          setPagination(prev => ({
            ...prev,
            current: 1,
            total: response.totalElements,
            pageSize: response.totalElements > 0 ? response.totalElements : 10,
          }));
          totalPageSizeSet.current = true;
        }

        // message.info(`Found ${response.totalElements} results`);
      } catch (error) {
        console.error("Search error:", error);
        message.error("Search failed. Please try again.");
      }
    }, 300),
    [props.accessToken, reportId, pagination.pageSize]
  );



  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };

  const fetchPayoutLandataChanelWise = async (current, pageSize) => {
    setDownloading(true);
    try {
      const response = await props.payoutLandataChanelWiseAction({
        accessToken: props.accessToken,
        reportId: reportId,
        page: current - 1,
        records: pageSize,
      });

      const errorCode = response?.response?.status;
      if (
        errorCode === 403
      ) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }

      if (response) {
        setLanDatasource(response.content || []);
        // message.info(`Found ${response.content.length} results`);
        setPagination((prev) => ({
          ...prev,
          current: current,
          pageSize: pageSize,
          total: response.totalElements,
        }));
      }

    } catch (error) {
      console.error("Error fetching payout landata:", error);
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    const run = async () => {
      await fetchPayoutLandataChanelWise(pagination.current, pagination.pageSize);
    };
    run();
  }, [reportId]);

  // const handelAddReamapRemark = async (data) => {
  //   try {
  //     const res = await props.addReamapAction({
  //       accessToken: props.accessToken,
  //       Remapdata: data,
  //     });

  //     const errorCode = res?.data?.error?.errorCode || res.errorCode;
  //     if (
  //       errorCode &&
  //       errorCode === 403 &&
  //       (res?.data?.error?.errorCode || res.errorCode)
  //     ) {
  //       handleSessionExpired(); //Logout the user if session expired
  //       return;
  //     }

  //      if (
  //       errorCode &&
  //       errorCode === 500 &&
  //       (res?.data?.error?.errorCode || res.errorCode)
  //     ) {
  //      message.error(res?.data?.error?.message || res.message || "Failed to remap partner");
  //     }

  //     console.log("res from add reamap remark", res);
  //     await fetchPayoutLandataChanelWise(pagination.current, pagination.pageSize);
  //     return res;
  //   } catch (error) {
  //     console.error("Error adding reamap remark:", error);
  //     return error;
  //   }
  // };

  const handelAddReamapRemark = async (data) => {
    try {
      const res = await props.addReamapAction({
        accessToken: props.accessToken,
        Remapdata: data,
      });

      const errorCode = res?.data?.error?.errorCode || res.errorCode;

      if (errorCode) {
        if (errorCode === 403) {
          handleSessionExpired();
          return;
        }

        if (errorCode === 500) {
          message.error(res?.data?.error?.message || res.message || "Failed to remap partner");
          return;
        }

        // Handle unexpected error codes
        message.error(`Unexpected error occurred: ${res?.data?.error?.message || res.message || "Unknown error"}`);
        return;
      }

      await fetchPayoutLandataChanelWise(pagination.current, pagination.pageSize);
      return res;
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Error adding reamap remark:", error);
      message.error("An unexpected error occurred while adding remap remark. Please try again.");
      return error;
    }
  };


  const handlePageChange = async (page, pageSize) => {
    // Call the API with the new page and pageSize
    const res = await fetchPayoutLandataChanelWise(page, pageSize);
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
    }));
    // setPagination((prev) => ({
    //   ...prev,
    //   total: res?.totalElements,
    // }));
  };


  const partnerList2 = useMemo(async () => {
    const partnerdata = props.getPartnerList({
      accessToken: props.accessToken,
    });
    const respartnerdata = await partnerdata;
    const errorCode =
      respartnerdata?.response?.status || respartnerdata.errorCode;
    if (
      errorCode &&
      errorCode === 403 &&
      (respartnerdata?.response?.status || respartnerdata.errorCode)
    ) {
      handleSessionExpired(); // Logout the user if session expired
      return null;
    }
    return respartnerdata;
  }, [props.accessToken, props.getPartnerList]);

  useEffect(() => {
    partnerList2.then((data) => {
      if (data) {
        setPartnerList(data);
      }
    });
  }, [partnerList2]);

  return (
    <div style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
              type="default"
              style={{
                margin: "0",
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '2px', // space between icon and text
                padding: '0 8px',
                color: '#00b1b1',
              }}
              onClick={() => navigate(-1)}
            >
              <LeftCircleOutlined />
              Back
            </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
      <Row className='d-flex justify-content-end'>
        <Col
          md={3}
          style={{
            display: "flex",
            float: "right",
            marginTop: "100px",
            // justifyItems: "end",
            // alignItems: "end",
            justifyContent: "flex-end",
          }}
        >
          <Input
            //  disabled={!searchlandatasource.length}
            className="search-input"
            allowClear
            placeholder="Search..."
            suffix={<SearchOutlined />}
            // prefix={
            //   searchTextTable && (
            //     <CloseOutlined
            //       onClick={clearSearch}
            //       style={{ cursor: "pointer" }}
            //     />
            //   )
            // }
            value={searchTextTable}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "20px" }}>
        <LanListChanelWiseWithPayout
          landatasource={landatasource}
          partnerList={partnerList.length > 0 ? partnerList.sort((a, b) => {

            if (a.pricingAdded === true && b.pricingAdded === false) {
              return -1;
            }

            if (a.pricingAdded === false && b.pricingAdded === true) {
              return 1;
            }

            return 0;
          }) : []}
          pagination={pagination}
          onPageChange={handlePageChange}
          handelAddRemap={handelAddReamapRemark}
          fileStatus={status}
          getfilemonth={getfilemonth}
          prevMonthName={prevMonthShortName}
          downloading={downloading}
        />
      </Row>
    </div>
  )
}



const mapStateToProps = (state) => {
  return {
    pricingpartnerdata: state.payoutLanDataReducer.pratnerdata,
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutLandataChanelWiseAction: (data) => dispatch(payoutLandataChanelWiseAction(data)),
    getPartnerList: (data) => dispatch(getPricingPartnerdata(data)),
    addReamapAction: (data) => dispatch(addReamapRemarkAction(data)),
    payoutPartnerChannelWiseLansearch: (data) => dispatch(payoutPartnerChannelWiseLansearch(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanListDetailChanalwise)